import React from 'react';
import { Camera, Film, Plane, Globe, Paintbrush, Share2, ExternalLink, BoxIcon } from 'lucide-react';
const marketingCapabilities = [{
  id: 'professional_photography',
  label: 'Professional photography',
  icon: Camera,
  evidence: '#'
}, {
  id: 'video_tour',
  label: 'Video tours',
  icon: Film,
  evidence: '#'
}, {
  id: 'virtual_tour_3d',
  label: '3D virtual tours',
  icon: BoxIcon,
  evidence: '#'
}, {
  id: 'drone_photography',
  label: 'Drone photography',
  icon: Plane,
  evidence: '#'
}, {
  id: 'property_website',
  label: 'Property websites',
  icon: Globe,
  evidence: '#'
}, {
  id: 'staging',
  label: 'Staging consultation',
  icon: Paintbrush,
  evidence: null
}, {
  id: 'social_media_marketing',
  label: 'Social media marketing',
  icon: Share2,
  evidence: '#'
}];
export function AgentCapabilities() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-39">
      <div className="mb-6" data-id="element-40">
        <h2 className="text-2xl font-serif text-brand-dark mb-2" data-id="element-41">
          What this agent brings
        </h2>
        <p className="text-sm text-brand-muted" data-id="element-42">
          Marketing tools and services verified from public listings
        </p>
      </div>

      <div className="flex flex-wrap gap-2" data-id="element-43">
        {marketingCapabilities.map(cap => {
        const Icon = cap.icon;
        return <div key={cap.id} className="inline-flex items-center gap-2 px-4 py-2.5 bg-brand-sandstoneBg border border-brand-sandstone/40 rounded-full text-sm text-brand-driftwood hover:border-brand-clay/60 transition-colors group" data-id="element-44">
              <Icon size={15} className="text-brand-clay" data-id="element-45" />
              <span className="font-medium" data-id="element-46">{cap.label}</span>
              {cap.evidence && <a href={cap.evidence} className="opacity-0 group-hover:opacity-70 transition-opacity" data-id="element-47">
                  <ExternalLink size={12} data-id="element-48" />
                </a>}
            </div>;
      })}
      </div>
    </section>;
}